$(document).ready(function() {

	$('.accords__label').on('click', function() {
		const $this = $(this);

		$this
			.siblings('.accords__content')
			.slideToggle()
			.parent()
			.toggleClass('open')
			.siblings()
			.removeClass('open')
			.find('.accords__content')
			.slideUp();
	});

	// open first on load
	$('.accords__accord')
		.eq(0)
		.addClass('open')
		.find('.accords__content')
		.show();

});